import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { CoreModule } from '../core/core.module';


const SharedModuleList = [
  ComponentsModule,
  CoreModule
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModuleList
  ],
  exports: [
    SharedModuleList
  ]
})
export class SharedModule { }
